import { MakeApiCall } from "../../../../apis";

export async function fetchAvailablePlans(token) {
  const res = await MakeApiCall(
    "admin/billing/coupons/available-plans",
    "get",
    null,
    true,
    {},
    token
  );
  if (!res?.status) {
    throw new Error(res?.message || "Failed to load available plans");
  }
  return res?.data?.plans || [];
}

export async function fetchCoupons({ page = 1, perPage = 20 } = {}, token) {
  const params = new URLSearchParams({
    page: String(page),
    per_page: String(perPage),
  });
  const res = await MakeApiCall(
    `admin/billing/coupons?${params.toString()}`,
    "get",
    null,
    true,
    {},
    token
  );
  if (!res?.status) {
    throw new Error(res?.message || "Failed to load coupons");
  }
  return {
    coupons: res?.data?.coupons || [],
    pagination: res?.data?.pagination || {
      total: 0,
      page: 1,
      per_page: perPage,
      pages: 1,
    },
  };
}

export async function createCoupon(payload, token) {
  const res = await MakeApiCall(
    "admin/billing/coupons",
    "post",
    payload,
    true,
    {},
    token
  );
  if (!res?.status) {
    throw new Error(res?.message || "Failed to create coupon");
  }
  return res;
}
